/**
 * The rendered wheel component container.
 */
import React, { PropTypes } from 'react';
import WheelMainMenu from './WheelMainMenu';

function WheelComponent({
  hoveredAspect,
  pieSlices,
  listItems,
  wheelAspects,
}) {
  return (
    <div className="wheel">
      <div className="wheel-shadow" />
      <WheelMainMenu
        hoveredAspect={hoveredAspect}
        listItems={listItems}
        pieSlices={pieSlices}
      />
    </div>
  );
}

WheelComponent.propTypes = {
  hoveredAspect: PropTypes.string,
  listItems: PropTypes.arrayOf(PropTypes.shape({})),
  pieSlices: PropTypes.func,
  wheelAspects: PropTypes.shape({}),
};

export default WheelComponent;



// WEBPACK FOOTER //
// js/src/wheel/WheelComponent.js